import Dropdown from './components/Dropdown';
import {
  DropdownWrapper,
  DropdownSelector,
  SelectorSearch,
  SelectedValue,
  Placeholder,
  Arrow,
  OptionContainer,
  GroupContainer,
  GroupHeading,
  GroupDivider,
  OptionItemWrap,
} from './styles';

export default Dropdown;
export {
  OptionRendererFunction,
  ItemRenderer,
  Option,
  OptionGroup,
  DropdownOption,
  DropdownStyleDependantState,
  DropdownProps,
} from './utils/types';
export { OptionItemProps } from './components/OptionItem';
export {
  RdaTheme,
} from './styles';

export const StyledDropdownComponents = {
  DropdownWrapper,
  DropdownSelector,
  SelectorSearch,
  SelectedValue,
  Placeholder,
  Arrow,
  OptionContainer,
  GroupContainer,
  GroupHeading,
  GroupDivider,
  OptionItemWrap,
};
